import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';


/**
 * Service providing donation status information
 */
@Injectable({
  providedIn: 'root'
})
export class DonationService {

  /**
   * Get the current donation status
   */
  getDonationStatus(): Observable<{current: string, target: string }> {
    return of({
      current: '9900',
      target: '13000'
    });
  }
}
